import { Link } from "react-router-dom";
import { getCategoryImage } from "@/lib/catalog";
import { useT } from "@/lib/i18n";
import { cdnImage, IMG } from "@/lib/img";

/**
 * Uitgelicht-sectie direct onder de hero: 3 vaste highlight-kaarten in Coolblue-stijl
 * (witte kaart, oranje badge, blauwe titel, productfoto rechts). VAST in de site (niet via
 * admin) — aanpassen = deze HIGHLIGHTS-constanten wijzigen. `imageSlug` haalt een
 * categoriefoto op; `badge` is het oranje labeltje linksboven.
 */
const HIGHLIGHTS: { badge: string; title: string; subtitle: string; to: string; imageSlug?: string; img?: string; accent?: boolean }[] = [
  { badge: "Nieuw", title: "Glas laten plaatsen", subtitle: "Liever uit handen geven? Glas mét montage — vraag een offerte aan.", to: "/glas-laten-plaatsen", accent: true },
  { badge: "Uitgelicht", title: "Glas op maat", subtitle: "Op de millimeter op maat gemaakt, direct de prijs.", to: "/glassoorten", img: "/glas-op-maat.webp" },
  { badge: "Uitgelicht", title: "Isolatie- & vacuümglas", subtitle: "HR++, triple en ultradun vacuümglas.", to: "/categorie/isolatieglas", img: "/glas-foto/beng-monu.webp" },
];

export function FeaturedHighlights() {
  const t = useT();
  return (
    <section aria-label={t("Uitgelicht")} className="mx-auto max-w-[1600px] px-4 pt-4 sm:pt-6">
      {/* Mobiel: horizontale snap-rij (85%-kaarten); vanaf sm een 3-koloms grid. */}
      <div className="flex snap-x snap-mandatory gap-3 overflow-x-auto pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:grid sm:snap-none sm:gap-4 sm:overflow-visible sm:pb-0 sm:grid-cols-3">
        {HIGHLIGHTS.map((h) => {
          const img = h.img ?? (h.imageSlug ? getCategoryImage(h.imageSlug) : undefined);
          return (
            <Link
              key={h.to}
              to={h.to}
              className="group relative flex min-h-[150px] shrink-0 basis-[85%] snap-start items-center gap-4 overflow-hidden rounded-2xl border border-primary-100 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-primary-300 hover:shadow-md sm:shrink sm:basis-auto"
            >
              <span className={`absolute left-4 top-4 rounded px-2 py-0.5 text-[11px] font-bold lowercase tracking-wide text-white ${h.accent ? "bg-[#013878]" : "bg-accent-700"}`}>
                {t(h.badge)}
              </span>
              <div className="mt-6 flex-1">
                <h3 className="text-lg font-extrabold leading-tight text-[#013878]">{t(h.title)}</h3>
                <p className="mt-1 text-sm text-primary-600">{t(h.subtitle)}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-sm font-bold text-accent-700 transition group-hover:gap-2">
                  {t("Bekijk")}
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                </span>
              </div>
              {img && (
                <img
                  src={cdnImage(img, { w: IMG.thumb })}
                  // De kaarttitel als alt: deze foto's zijn inhoudelijk (een glassoort, een
                  // vacuümglas-pakket), geen versiering. Met een lege alt slaat een schermlezer
                  // ze over en ziet Google Afbeeldingen niet waar ze over gaan.
                  alt={t(h.title)}
                  loading="lazy"
                  decoding="async"
                  className="h-24 w-24 shrink-0 object-contain transition-transform duration-500 group-hover:scale-105"
                />
              )}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
